import { render, staticRenderFns } from "./RouteItemEditor.vue?vue&type=template&id=51588241&"
import script from "./RouteItemEditor.vue?vue&type=script&lang=js&"
export * from "./RouteItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./RouteItemEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports